var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEkata = function SvgEkata(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 8.15439V6.33099C14.8047 6.14819 14.6684 6 14.5003 6H7.49969C7.33159 6 7.19531 6.14819 7.19531 6.33099V15.669C7.19531 15.8518 7.33159 16 7.49969 16H14.5003C14.6684 16 14.8047 15.8518 14.8047 15.669V13.9333C14.8047 13.7505 14.6684 13.6023 14.5003 13.6023H9.94652C9.77842 13.6023 9.64215 13.4541 9.64215 13.2713V8.81637C9.64215 8.63357 9.77842 8.48538 9.94652 8.48538H14.5003C14.6684 8.48538 14.8047 8.33719 14.8047 8.15439Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3945 11.6631V10.3076C10.3945 10.1248 10.5308 9.97656 10.6989 9.97656H13.5319C13.7 9.97656 13.8362 10.1248 13.8362 10.3076V11.6631C13.8362 11.8459 13.7 11.9941 13.5319 11.9941H10.6989C10.5308 11.9941 10.3945 11.8459 10.3945 11.6631Z",
    fill: "#595959"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "#D9D9D9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEkata);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ekata.2f4931a789bc3e2bad14a7764b13d392.svg";